export default __webpack_public_path__ + "static/media/slider-img1.67aa5053.jpg";